export const SET_ITEMS = 'set-items';
export const CLEAR_ITEMS = 'clear-items';
